import request from '@/utils/request'
const BASE_URL = '/files'

export default {
  uploadXml(data) {
    return request({
      url: BASE_URL,
      method: 'post',
      data
    })
  },
}